import BaseAction from "./base_action";
import { GET_LIBRARY_CONTROL_REVIEWS, LIBRARY_CONTROL_REVIEWS_MARK_AS_REVIEWED } from '../constants'

export default class LibraryControlReviewAction extends BaseAction {

  //TODO: It's better to handle '/__api/v1' in the API Service
  //Peer review comment: https://gitlab.com/objectit/anglo-debeers-wrac/-/merge_requests/48#note_1317965078
  getLibraryControlReviews = (plan_id) => {
    const action = GET_LIBRARY_CONTROL_REVIEWS;
    const url = `/__api/v1/plans/${plan_id}/library_control_reviews`;
    return this.apiGet(action, url, {});
  }

  markLibraryControlReviewsAsReviewed = (review_ids) => {
    const action = LIBRARY_CONTROL_REVIEWS_MARK_AS_REVIEWED;
    const url = `/__api/v1/library_control_reviews/mark_as_reviewed`;
    const params = {
      review_ids: review_ids
    }
    return this.apiPut(action, url, params);
  }

}


// WEBPACK FOOTER //
// ./src/actions/library_control_review.js